export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-information-line text-sm w-4 h-4 flex items-center justify-center"></i>
            平台介绍
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">关于桔子影视</h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              桔子影视成立于 2020 年，是一个专注于高清电视剧在线播放的综合平台。
              我们致力于为广大追剧爱好者提供最新、最全、最高清的电视剧全集资源，
              涵盖国产剧、韩剧、美剧、日剧、泰剧及海外热门剧集，类型横跨古装、都市、悬疑、科幻、喜剧等多个领域。
            </p>
            <p>
              平台采用先进的视频加速技术与智能 CDN 分发系统，确保播放流畅不卡顿，
              支持 1080P 至 4K 多种画质自由切换。所有内容均经过精心筛选与整理，
              提供完整剧集导航、分集播放、剧情简介与演员信息，让您追剧不迷路。
            </p>
            <p>
              桔子影视始终坚持「免费 · 高清 · 全」的核心理念，无需注册、无需付费即可畅享全部内容。
              我们的编辑团队每日更新剧集资源，紧跟播出节奏，确保您不错过任何一个精彩瞬间。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {[
              { num: '50,000+', label: '剧集资源' },
              { num: '30+', label: '每日更新' },
              { num: '4K', label: '超清画质' },
              { num: '99.9%', label: '播放稳定率' },
            ].map((stat) => (
              <div key={stat.label} className="bg-background-100 rounded-xl p-4 md:p-5">
                <p className="text-xl md:text-2xl font-heading text-primary-500 mb-1">{stat.num}</p>
                <p className="text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}